import examReducer from './examReducer';

const examReducers ={
  exam: examReducer,
};

export default examReducers;